import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Site } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createSiteApi, siteKeys } from '../api';

export function useSite(id: string | null, enabled = true): UseQueryResult<Site> {
  const client = useApiClient('admin-auth');
  const api = createSiteApi(client);

  const siteId = id ?? '';

  return useQuery({
    enabled: enabled && id !== null,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getSite(siteId),
    queryKey: siteKeys.detail(siteId),
    staleTime: LIST_STALE_TIME_MS,
  });
}
